import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppConfig } from '@config/app.config';

@Component({
  selector: 'app-alert-delete-view',
  templateUrl: './alert-delete-view.component.html'
})
export class AlertDeleteViewComponent implements OnInit {
  public success: string;
  public error: Array<string>;

  constructor(
    public appConfig: AppConfig,
    public dialogRef: MatDialogRef<AlertDeleteViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    this.success = this.data.success;
    this.error = this.data.error;
  }

  close(response: number) {
    this.dialogRef.close(response);
  }
}
